import React from "react";
import { useSelector } from "react-redux";

import { OnboardingDialog } from "@src/components/MainApp/Onboarding/OnboardingDialog";
import { isDialogOpen } from "@src/store/slices/global";

import { MissingShopifyScopeDialog } from "../components/Dialogs/MissingShopifyScopeDialog";
import { ScriptTagDialog } from "../components/Dialogs/ScriptTagDialog";
import { UpdateDetectedDialog } from "../components/Dialogs/UpdatedDetectedDialog";

export const DialogProvider = () => {
  const isScriptTagDialogOpen = useSelector(isDialogOpen("scriptTag"));
  return (
    <>
      <MissingShopifyScopeDialog />
      <UpdateDetectedDialog />
      {isScriptTagDialogOpen && <ScriptTagDialog />}
      <OnboardingDialog />
    </>
  );
};
